/**
 * @file バリデーションエラーメッセージ（Atom）。FieldErrorが存在する場合のみエラーテキストを表示。
 */
import { FieldError } from 'react-hook-form';

type Props = Partial<{
  error: FieldError;
}>;

const AtErrorMessage = ({ error }: Props): JSX.Element | null => {
  return error ? <p className='note left'>{error?.message}</p> : null;
};

export default AtErrorMessage;
